import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  Avatar,
} from "@mui/material";
import Loader from "../../components/Loader";
import ApiService from "../../services/api-service";
import Back from "../../components/Back";
import { Images } from "../../assets/common";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ProfileMenu from "../../components/ProfileMenu";
import {
  convertHMS,
  copyToClipboard,
  generateDynamicLink,
  fullName,
  getErrorString,
  getUserDetail,
  isOwnerId,
  onShare,
  putRecors,
  truncate,
} from "../../constants/function";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import notifier from "../../components/Notifier";
import { useDispatch } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { addSongAction } from "../../action/songs";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import BuyNow from "../../components/BuyNow";
import "./index.scss";
import NftMoreData from "./nftMoreData";
import SellPopup from "../../components/SellPopup";
import IosSwitch from "../../components/IOSSwitch";
import AuctionPopup from "../../components/AuctionPopup";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import SuccessPopup from "../../components/SuccessPopup";
import BidPopup from "../../components/BidPopup";
import { SocketContext } from "../../context/socket";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import NoData from "../../components/Nodata";
import NftRank from "./NftRank";
import IosShareIcon from "@mui/icons-material/IosShare";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import SongNft from "../../components/SongNft";
import HMSTag from "../../components/HMS/hms";




function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{ minHeight: "300px" }}
    >
      {value === index && (
        <Box sx={{ padding: "10px 0" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function SongDetail() {
  const { t } = useTranslation("common");
  const userData = getUserDetail();
  const [innerLoader, setInnerLoader] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const [openBid, setOpenBid] = useState(false);
  const [openSingleBid, setOpenSingleBid] = useState({});
  const [openSingleBuy, openSetSingleBuy] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [owner, setOwner] = useState({});
  const [type, setType] = React.useState("music");
  const [showSell, setShowSell] = React.useState(false);
  const [showAuction, setShowAuction] = React.useState(false);
  const [showPlaylist, setShowPlaylist] = useState(false);
  const [owners, setOwners] = useState({});
  const [index, setIndex] = React.useState(-1);
  const [charge, setCharge] = React.useState({});
  const [inUsd, setInUsd] = React.useState(0);
  const [bidInUsd, setBidInUsd] = React.useState(0);
  const [buyOpen, setBuyOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { nftId } = useParams();
  const { playlistNftId } = useParams();
  const [musicDetail, setMusicDetail] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState(false);
  const [offers, setOffers] = React.useState([]);
  const [nft, setNft] = React.useState({});

  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const [activities, setActivities] = React.useState([]);
  const [nftrank, setNftrank] = React.useState([]);
  const [ownersData, setOwnersData] = React.useState([]);
  const [auctionsData, setAuctionsData] = React.useState([]);
  const [option, setOption] = React.useState(false);
  const params = new URLSearchParams(history.location.search);
  const referralId = params.get("referralId");
  const getMusicDetail = async (_id, sellingPrice, highestBid) => {
    try {
      getCharges(sellingPrice, highestBid);
      // setLoading(true);

      const response = await ApiService.MUSIC_DETAIL(_id);
      setMusicDetail({ ...response["result"] });
      if (window.location.href.includes("referralId="))
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["sharedInbound"],
          eventAsset: response["result"]?._id,
          eventValue: ["Music"],
          socialMedia: null,
          referralId: referralId,
        });
      else
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["view"],
          eventAsset: response["result"]?._id,
          eventValue: ["Music"],
          socialMedia: null,
        });
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      }
    }
  };

  const getNftDetails = async (nftId) => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_BY_ID_V2(nftId);

      if (response["result"] && !response["result"]["playlistDetails"]) {
        setOwners(response["result"]);
        setChecked(response["result"]["private"]);
        setNft(response["result"]);
      }
      getOwnersData(response["result"]["id"]);
      await getMusicDetail(
        response["result"]["id"],
        response["result"]["sellingPrice"],
        response["result"]["highestBid"]
      );

      setLoading(false);
    } catch (error) {
      console.log( error );
      setLoading(false);
    }
  };
  const play = () => {
    if (
      musicDetail["owner"] &&
      !isOwnerId(musicDetail["owner"]["_id"]) &&
      !musicDetail["uploader"]["isSubscribed"] &&
      musicDetail["private"]
    )
      notifier.error(t("notifier.error.toast5"));
    else dispatch(addSongAction(musicDetail, null, true));
  };
  const toggleMenu = (value, id, index) => {};
  useEffect(() => {
    getNftDetails(nftId);
  }, [nftId]);
  React.useEffect(() => {}, []);

  const getCharges = async (sellingPrice, highestBid) => {
    try {
      const price = sellingPrice || 0;
      const response = await ApiService.CHARGES();
      setCharge({ ...response["result"] });
      setInUsd(price * response["result"]["rate"]);
      const d = highestBid * response["result"]["rate"];
      // console.log(d); //
      setBidInUsd((prev) => (prev = d));
    } catch (error) {}
  };
  const handleSell = (sellAmount) => {
    if (sellAmount) {
      getNftDetails(nftId);
      setShowSell(false);
    } else {
      setShowSell(false);
    }
  };

  //NOTE: Switch handleer
  const handleChange = (value) => {
    markPrivate(value);
  };

  const markPrivate = async () => {
    try {
      const privacy = !owners.private;
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: owners["_id"],
        type: "nft",
        private: privacy,
      });
      const response1 = await ApiService.ASSET_PRIVACY({
        assetId: owners["id"],
        type: "music",
        private: privacy,
      });
      //making playlist publisc/private
      const temp = owners;
      setChecked(privacy);
      temp.private = privacy;
      setOwners({ ...temp });
      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  const handleAuction = (sellAmount) => {
    if (sellAmount) {
      getNftDetails(nftId);
      setShowAuction(false);
    } else {
      setShowAuction(false);
    }
  };
  const cancelSell = async (type, nftId, isActiveAuctionTab) => {
    try {
      setLoading(true);
      const payload = {
        nftId: nftId,
        type: type,
      };
      const response = await ApiService.CANCEL_SELL_V2(payload);
      setLoading(false);
      getNftDetails(nftId);
      if (isActiveAuctionTab) getAuctionsData(musicDetail["_id"]);
      notifier.success(t("notifier.success.toast6"));
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const cancelAuction = async (type, id, isActiveAuctionTab) => {
    try {
      setLoading(true);
      const payload = {
        nftId: id ? id : nftId,
        type: type,
      };
      const response = await ApiService.CANCEL_AUCTION_NFT_V2(payload);
      setLoading(false);
      getNftDetails(nftId);
      if (isActiveAuctionTab) getAuctionsData(musicDetail["_id"]);
      notifier.success(t("notifier.success.toast5"));
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleBid = (bidAmount) => {
    if (bidAmount) {
      const ownersDetail = owners;
      ownersDetail["highestBid"] = parseInt(bidAmount["amount"]);
      setOwners({ ...ownersDetail });
      setOpenBid(false);
      setShowSuccess(true);
      setOpenSingleBid({});
    } else {
      setOpenBid(false);
      setOpenSingleBid({});
    }
  };
  const handleBuyed = (bidAmount) => {
    if (bidAmount) {
      openSetSingleBuy({});
      getNftDetails(nftId);
      getAuctionsData(musicDetail["_id"]);
    } else {
      openSetSingleBuy({});
    }
  };
  /**
   * @param  {} assetId
   * musicid
   */
  const getSales = async () => {
    try {
      setLoading(true);
      const response = await ApiService.OFFERS_SALE(owners["id"]);
      setOffers([...response["result"]]);
      setLoading(false);
      setBuyOpen(true);
    } catch (error) {
      setLoading(false);
    }
  };
  const getAuctions = async () => {
    try {
      setLoading(true);
      const response = await ApiService.OFFERS_AUCTION(owners["id"]);
      setOffers([...response["result"]]);
      setLoading(false);
      setBuyOpen(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const changeHandle = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) getOwnersData(musicDetail["_id"]);
    if (newValue === 2) getAuctionsData(musicDetail["_id"]);
  };

  const getOwnersData = async (musicId) => {
    setInnerLoader(true);
    try {
      const response = await ApiService.NFT_RANK(musicId);
      setOwnersData([...response["result"]]);
      setInnerLoader(false);
      findOwner(response["result"]);
    } catch (error) {
      setInnerLoader(false);
    }
  };
  const findOwner = (owners) => {
    const userData = getUserDetail();
    const owner = owners.find((o) => o.owner._id === userData._id);
    setOwner({ ...owner });
  };
  const getAuctionsData = async (musicId) => {
    setInnerLoader(true);
    try {
      const response = await ApiService.ACTIVE_BID(musicId);
      setAuctionsData(response["result"]);
      setInnerLoader(false);
    } catch (error) {
      setInnerLoader(false);
    }
  };
  const handleSingleBid = (nftData) => {
    setOpenSingleBid({ ...nftData });
  };
  const handleClick = (event) => {
    setOption(!option);
    putRecors({
      id: userData._id,
      referralLink: window.location.href,
      eventType: ["click"],
      eventAsset: musicDetail?._id,
      sharedBy: fullName(userData),
      eventValue: ["Music"],
      socialMedia: null,
    });
  };
  const handleClose = () => {
    setOption(false);
  };
  const handleCopy = async (action) => {
    const thumbnail = musicDetail.GIF?.filePath || musicDetail.thumbnailImg?.filePath;
    const url = await generateDynamicLink('song', musicDetail.nftId, musicDetail.title, '', thumbnail);
    
    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["click"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["click"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  
  return (
    <Box className="___song_detail">
      <Back />
      <Box className="overall">
        {musicDetail["_id"] ? (
          <Box className="___song_detail_box">
            <Box className="___song_detail_container">
              <Box className="___song_detail_banner">
                <Stack
                  className="___song_detail_banner_detail"
                  spacing={1.5}
                  direction="row"
                  gap="20px"
                  padding="20px 20px"
                >
                  <img
                    className="_img_large  br16"
                    src={
                      musicDetail["thumbnailImg"]
                        ? musicDetail["thumbnailImg"]["filePath"]
                        : musicDetail["GIF"]
                        ? musicDetail["GIF"]["filePath"]
                        : ""
                    }
                    alt="music"
                  />
                  <Stack
                    direction="column"
                    justifyContent="flex-start"
                    spacing={1}
                    sx={{ flex: "100%" }}
                  >
                    <Typography className="fs-24 fw-b">
                      {musicDetail["title"]}
                    </Typography>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <PlayArrowRoundedIcon
                        className="_cp"
                        title="play"
                        color="default"
                        onClick={() => play()}
                      />

                      {musicDetail["duration"] ? (
                        <HMSTag
                          className="white-secondary fs-14 fw-b"
                          duration={musicDetail["duration"]}
                        />
                      ) : null}
                    </Stack>

                    <Stack direction="row" spacing={2}>
                      {/* <Stack direction="row" alignItems="center" spacing={1}>
                        <VisibilityIcon className="white-secondary" />{" "}
                        <Typography className="fs-14 white-secondary ">
                          {t("nftDetail.detail.views")}: {musicDetail["views"]}
                        </Typography>
                      </Stack> */}
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        marginLeft="6px"
                      >
                        <img
                          style={{ width: "15px", height: "15px" }}
                          src={Images.listen}
                        />{" "}
                        <Typography className="fs-14 white-secondary ">
                          {t("analytics.card.card3")}: {musicDetail["listens"]}
                        </Typography>
                      </Stack>
                    </Stack>
                    {owners["rank"] ? (
                      <Typography
                        sx={{
                          marginTOp: "18px",
                          height: "30px",
                          fontSixe: "14px",
                          fontWeight: "bold",
                          width: "fit-content",
                          borderRadius: "10px",
                          background: "#ffffff30",
                          color: "#FFFFFFCC",
                          padding: "0 10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {owners["rank"]}/{owners["nftCount"]} NFTs
                      </Typography>
                    ) : null}

                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ marginTop: "auto !important" }}
                      className="__shareRow"
                    >
                      {/* {history.location.pathname.includes(
                        "/app/SongDetail/"
                      ) ? ( */}
                      <Box sx={{ position: "relative" }}>
                        <Button
                          className="__play_all "
                          onClick={handleClick}
                          sx={{
                            width: "96px",
                            height: "36px !important",
                            fontSize: "12px !important",
                            fontWeight: "400 !important",
                          }}
                          variant="outlined"
                          color="default"
                          startIcon={
                            <IosShareIcon
                              className="__play_all_play"
                              color="default"
                            />
                          }
                        >
                          {t("nftDetail.detail.share")}
                        </Button>
                        {option ? (
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              handleClose();
                            }}
                          >
                            <ProfileMenu
                              right={"0px"}
                              isHeader={true}
                              isLast={"40px"}
                              actions={[
                                { key: "m14", action: t("dropMenu.m14") },
                                { key: "m15", action: t("dropMenu.m15") },
                                { key: "m16", action: t("dropMenu.m16") },
                                // "Share on Instagram",
                              ]}
                              handleProfileMenuChoice={(action) => (
                                handleCopy(action), handleClose()
                              )}
                            />
                          </OutsideClickHandler>
                        ) : null}
                      </Box>
                      {/* ) : null} */}
                      {owners["owner"] && isOwnerId(owners["owner"]["_id"]) ? (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{
                            marginLeft: "auto !important",
                            width: "max-content",
                          }}
                        >
                          <Typography className="fs-16">
                            {t("visible")}{" "}
                            {owners["private"] ? t("private") : t("public")}
                          </Typography>
                          <IosSwitch
                            width={true}
                            checked={owners["private"]}
                            handleChange={handleChange}
                          />
                        </Stack>
                      ) : null}
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
              <Box className="__back_cover_Music_nft">
                <img
                  className=" mx-auto h100 w100 br16"
                  src={
                    musicDetail["thumbnailImg"]
                      ? musicDetail["thumbnailImg"]["filePath"]
                      : musicDetail["GIF"]
                      ? musicDetail["GIF"]["filePath"]
                      : ""
                  }
                  alt="music"
                />
                <Box className="_cover_shadow"></Box>
              </Box>
            </Box>

            <Box sx={{ position: "relative", width: "100%" }}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider" }}
                position="static"
              >
                <Tabs
                  value={value}
                  onChange={changeHandle}
                  indicatorColor="primary"
                  variant="fullWidth"
                  aria-label="Nft more details"
                >
                  <Tab
                    className="responsive-flex"
                    sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
                    label={t("nftDetail.tabs1.tab1")}
                  />
                  <Tab
                    className="responsive-flex"
                    sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
                    label={t("nftDetail.tabs1.tab2")}
                  />
                  <Tab
                    className="responsive-flex"
                    sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
                    label={t("nftDetail.tabs1.tab3")}
                  />
                </Tabs>
              </Box>
              <Box
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
              >
                <TabPanel value={value} index={0} dir={theme.direction}>
                  <Typography className="fs-4 letter0 mt-20">
                    {truncate(musicDetail["description"], 319)}{" "}
                    {musicDetail["description"].length > 319 ? (
                      <span style={{ color: "#FFEE20" }}>
                        {t("nftDetail.detail.readMore")}
                      </span>
                    ) : null}
                  </Typography>
                  <Stack spacing={2} className="___song_detail_more">
                    <Stack spacing={1.5} className="mt-30">
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography className="fs-14 fw-b">
                          {t("nftDetail.detail.ownedBy.text1")}
                        </Typography>
                        <Typography className="fs-14 faded">
                          {musicDetail["ownerRoyalty"]}%{" "}
                          {t("nftDetail.detail.ownedBy.text2")}
                        </Typography>
                      </Stack>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Avatar
                          src={
                            owners &&
                            owners["owner"] &&
                            owners["owner"]["profileImg"]["filePath"] !== ""
                              ? owners["owner"]["profileImg"]["filePath"]
                              : Images.default_user
                          }
                          alt=""
                        />
                        <Typography className="fs-14">
                          {fullName(owners["owner"])}
                        </Typography>
                        {owners && owners["isVerified"] ? (
                          <DoneIcon
                            color="primary"
                            sx={{
                              backgroundColor: "#2CF488",
                              borderRadius: "50%",
                              fontSize: "14px",
                              color: "#1E1E1E",
                              padding: "2px",
                            }}
                          />
                        ) : null}
                      </Stack>
                    </Stack>
                    {/* NOTE:For Other user */}
                    {/* {owners["owner"] &&
                    !isOwnerId(owners["owner"]["_id"]) &&
                    !owner["owner"] ? (
                      <Stack
                        className="___buy_option"
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Stack>
                          <Stack>
                            <Typography className="fs-14 white-secondary">
                              {t("nftDetail.detail.sale")}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "20px", height: "20px" }}
                                src={Images.siki_coin}
                                alt="siki"
                              />
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Typography className="fs-24 fw-b">
                                  {owners["sellingPrice"]
                                    ? owners["sellingPrice"].toFixed(1)
                                    : "0.0"}
                                </Typography>
                                <Typography>($ {inUsd.toFixed()})</Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                          <Stack>
                            <Typography className="fs-14 white-secondary">
                              {t("nftDetail.detail.bidText")}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "20px", height: "20px" }}
                                src={Images.siki_coin}
                                alt="siki"
                              />
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Typography className="fs-24 fw-b">
                                  {owners["highestBid"]
                                    ? owners["highestBid"].toFixed(1)
                                    : "0.0"}
                                </Typography>
                                <Typography>
                                  ($ {bidInUsd.toFixed()})
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          {owners["onSale"] ? (
                            <Button
                              className="height50"
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                getSales();
                              }}
                            >
                              Buy Now
                            </Button>
                          ) : null}
                          {owners["onAuction"] ? (
                            <Button
                              className="height50"
                              variant="outlined"
                              color="default"
                              onClick={() => {
                                getAuctions();
                              }}
                            >
                              Place Bid
                            </Button>
                          ) : null}
                        </Stack>
                      </Stack>
                    ) : null} */}
                    {/* NOTE:put on sale for owner */}
                    {(owners["owner"] && isOwnerId(owners["owner"]["_id"])) ||
                    owner["owner"] ? (
                      <Stack
                        className="___buy_option"
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        {/* <Stack>
                          <Stack>
                            <Typography className="fs-14 white-secondary">
                              {t("nftDetail.detail.priceText")}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "20px", height: "20px" }}
                                src={Images.siki_coin}
                                alt="siki"
                              />
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Typography className="fs-24 fw-b">
                                  {owners["sellingPrice"]
                                    ? owners["sellingPrice"].toFixed(1)
                                    : "0.0"}
                                </Typography>
                                <Typography>(${inUsd.toFixed()})</Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                          <Stack>
                            <Typography className="fs-14 white-secondary">
                              {t("nftDetail.detail.bidText")}
                            </Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "20px", height: "20px" }}
                                src={Images.siki_coin}
                                alt="siki"
                              />
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Typography className="fs-24 fw-b">
                                  {owners["highestBid"]
                                    ? owners["highestBid"].toFixed(1)
                                    : "0.0"}
                                </Typography>
                                {owners["highestBid"] ? (
                                  <Typography>
                                    (${bidInUsd.toFixed()})
                                  </Typography>
                                ) : null}
                              </Stack>
                            </Stack>
                          </Stack>
                        </Stack> */}
                        <Stack
                          direction="row"
                          alignItems="flex-start"
                          gap="10px"
                        >
                          {owners["onSale"] && owners["isMaster"] ? (
                            <Button
                              className="height50 "
                              variant="contained"
                              color="primary"
                              sx={{ width: "130px" }}
                              onClick={() => {
                                setType(nftId ? "music" : "playlist");
                                setShowSell(true);
                              }}
                            >
                              {t("nftDetail.detail.button")}
                            </Button>
                          ) : null}
                          {owners["onSale"] ? (
                            <Button
                              className="height50 _pre_space"
                              variant="outlined"
                              color="error"
                              sx={{
                                width: "170px",
                                justifyContent: "flex-start",
                              }}
                              onClick={() => {
                                setType("music");
                                cancelSell("music", nftId);
                              }}
                              startIcon={<CancelTwoToneIcon />}
                            >
                              {t("nftDetail.detail.button3")}
                            </Button>
                          ) : (
                            <Button
                              className="height50"
                              variant="contained"
                              color="primary"
                              sx={{ width: "130px" }}
                              onClick={() => {
                                setType(nftId ? "music" : "playlist");
                                setShowSell(true);
                              }}
                            >
                              {t("nftDetail.detail.button1")}
                            </Button>
                          )}
                          {/* NOTE:Auction is compressed for now */}
                          {owners["onAuction"] && owners["isMaster"] ? (
                            <Button
                              className="height50"
                              variant="outlined"
                              color="default"
                              sx={{ width: "130px" }}
                              onClick={() => {
                                setType("music");
                                setShowAuction(true);
                              }}
                            >
                              {t("nftDetail.detail.button2")}
                            </Button>
                          ) : null}
                          {owners["onAuction"] ? (
                            <Button
                              className="height50 _pre_space"
                              variant="outlined"
                              color="error"
                              sx={{
                                width: "170px",
                                justifyContent: "flex-start",
                              }}
                              onClick={() => {
                                setType("music");
                                cancelAuction("music");
                              }}
                              startIcon={<CancelTwoToneIcon />}
                            >
                              {t("nftDetail.detail.button4")}
                            </Button>
                          ) : (
                            <Button
                              className="height50"
                              variant="outlined"
                              color="default"
                              sx={{ width: "130px" }}
                              onClick={() => {
                                setType("music");
                                setShowAuction(true);
                              }}
                            >
                              {t("nftDetail.detail.button2")}
                            </Button>
                          )}
                        </Stack>
                      </Stack>
                    ) : null}
                    {owners ? (
                      <NftMoreData musicDetail={musicDetail} owners={owners} />
                    ) : null}
                  </Stack>
                </TabPanel>

                <TabPanel value={value} index={1} dir={theme.direction}>
                  <Stack sx={{ position: "relative", minHeight: "200px" }}>
                    <Stack spacing={1}>
                      {ownersData.length > 0 ? (
                        ownersData.map((oData, index) => (
                          <NftRank
                            key={index}
                            data={oData}
                            isAuction={false}
                            handleSell={(nftId) => {
                              setType("music");
                              setShowSell(true);
                            }}
                            handleAuction={(nftId) => {
                              setType("music");
                              setShowAuction(true);
                            }}
                          />
                        ))
                      ) : (
                        <NoData lable={t("noData.noData")} />
                      )}
                    </Stack>
                    {innerLoader ? (
                      <Loader
                        wait={true}
                        _class="__loader_inside"
                        message={t("loader.message16")}
                      />
                    ) : null}
                  </Stack>
                </TabPanel>

                <TabPanel value={value} index={2} dir={theme.direction}>
                  <Stack sx={{ position: "relative", minHeight: "200px" }}>

                    <Stack spacing={1}>
                      {auctionsData.length > 0 ? (
                        auctionsData.map((oData, index) => (
                          <NftRank
                            key={index}
                            data={oData}
                            isAuction={true}
                            cancelAuction={(nftId) =>
                              cancelAuction("music", nftId, true)
                            }
                            cancelSell={(nftId) =>
                              cancelSell("music", nftId, true)
                            }
                            handleBid={(data) => {
                              setOpenSingleBid({ ...data });
                            }}
                            handleBuy={(data) => openSetSingleBuy({ ...data })}
                          />
                        ))
                      ) : (
                        <NoData lable={t("noData.noData")} />
                      )}
                    </Stack>
                    {innerLoader ? (
                      <Loader
                        wait={true}
                        _class="__loader_inside"
                        message={t("loader.message7")}
                      />
                    ) : null}
                  </Stack>
                  {/* <ActiveBid /> */}
                </TabPanel>
              </Box>
            </Box>
          </Box>
        ) : null}
        {musicDetail["_id"] ? (
          <SongNft musicDetail={musicDetail} value={nft} />  
        ) : null}
      </Box>
      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={musicDetail["_id"]}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}

      {buyOpen ? (
        <BuyNow
          offers={offers}
          open={buyOpen}
          handleClose={(bidAmount) => {
            setBuyOpen(false);
            const bidData = {
              auctionId: owners.auctionId,
              bidDifference: owners.highestBid,
              amount: bidAmount.amount,
              userDetail: owners.owner,
            };
            socket.emit("bidding", bidData);
            getNftDetails(nftId);
          }}
          type={"music"}
        />
      ) : null}
      {showSell ? (
        <SellPopup
          rank={owners["rank"]}
          isMaster={true}
          assetId={musicDetail["_id"]}
          type={type}
          open={showSell}
          handleClose={(amount) => handleSell(amount)}
          nftId={nftId ? owners["_id"] : musicDetail["_id"]}
          nftCount={
            nftId
              ? typeof owners["inSaleCount"] === "undefined"
                ? owners["currentCount"]
                : owners["currentCount"] > owners["inSaleCount"]
                ? owners["currentCount"]
                : owners["inSaleCount"]
              : musicDetail["inSaleCount"]
              ? musicDetail["inSaleCount"]
              : musicDetail["nftCount"]
          }
        />
      ) : null}
      {showAuction ? (
        <AuctionPopup
          rank={owners["rank"]}
          isMaster={true}
          assetId={musicDetail["_id"]}
          type={type}
          open={showAuction}
          handleClose={(amount) => handleAuction(amount)}
          nftId={owners["_id"]}
        />
      ) : null}
      {openBid ? (
        <BidPopup
          highestBid={owners["highestBid"] ? owners["highestBid"] : 100}
          open={openBid}
          handleClose={(amount) => handleBid(amount)}
          auctionId={owners["auctionId"] ? owners["auctionId"] : 0}
          type="music"
        />
      ) : null}
      {openSingleBuy._id ? (
        <BidPopup
          isBuy={true}
          highestBid={openSingleBuy?.sellingPrice}
          open={true}
          handleClose={(amount) => handleBuyed(amount)}
          auctionId={openSingleBuy?._id} //this is nftId
          type={type}
        />
      ) : null}
      {openSingleBid && openSingleBid._id ? (
        <BidPopup
          highestBid={openSingleBid?.highestBid}
          open={true}
          handleClose={(amount) => handleBid(amount)}
          auctionId={openSingleBid["auctionId"]}
          type="music"
        />
      ) : null}
      {showSuccess ? (
        <SuccessPopup
          open={showSuccess}
          handleClose={() => setShowSuccess(false)}
          message={t("success.message2")}
        />
      ) : null}
    </Box>
  );
}
